import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';

import { EditTribute as EditTributeView } from '@modules/Tributes/Views/EditTribute/EditTribute';


export const EditTribute: React.FC = () => {
  const { tributeId } = useParams();
  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%" />}>
        <EditTributeView tributeId={tributeId} />
      </Suspense>
    </ErrorBoundary>
  );
};
